<template>
  <AppShell>
    <div class="page-head">
      <h1>Пользователи</h1>
      <v-btn color="primary" prepend-icon="mdi-account-plus-outline" @click="editUser({})">Пользователь</v-btn>
    </div>
    <v-alert v-if="error" type="error" variant="tonal" class="mb-4">{{ error }}</v-alert>
    <v-card variant="flat">
      <v-table>
        <thead>
          <tr><th>ID</th><th>Логин</th><th>Имя</th><th>Роли</th><th>Статус</th><th></th></tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td>{{ user.id }}</td>
            <td>{{ user.login }}</td>
            <td>{{ user.name }}</td>
            <td><v-chip v-for="role in user.roles" :key="role" size="small" class="mr-1" variant="tonal">{{ roleTitle(role) }}</v-chip></td>
            <td><v-chip :color="user.status === 'active' ? 'primary' : 'error'" size="small" variant="tonal">{{ user.status }}</v-chip></td>
            <td class="table-actions"><v-btn icon="mdi-pencil-outline" variant="text" @click="editUser(user)" /></td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
    <UserEditor v-model="editor" :user="draft" @save="saveUser" />
  </AppShell>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { api, unwrap } from '../api/http';
import AppShell from '../components/AppShell.vue';
import UserEditor from '../components/UserEditor.vue';
const users = ref([]);
const editor = ref(false);
const draft = ref({});
const error = ref('');
function roleTitle(role) { return role === 'admin' ? 'Супер администратор' : 'Психолог'; }
function editUser(user) { draft.value = { ...user, roles: [...(user.roles || [])] }; editor.value = true; }
async function loadUsers() { users.value = unwrap(await api.get('/api/users')); }
async function saveUser(form) {
  error.value = '';
  try {
    if (form.id) {
      await api.put(`/api/users/${form.id}`, { login: form.login, name: form.name, status: form.status });
      await api.put(`/api/users/${form.id}/roles`, { roles: form.roles });
      if (form.password) await api.put(`/api/users/${form.id}/password`, { password: form.password });
    } else {
      await api.post('/api/users', { login: form.login, name: form.name, password: form.password, roles: form.roles });
    }
    editor.value = false;
    await loadUsers();
  } catch (e) {
    error.value = e.response?.data?.message || e.message;
  }
}
onMounted(loadUsers);
</script>
